import {License} from "../modules/halls/reducers/inspectingHall.reducer";
import moment from "moment";

interface LicenseDates {
    daysLeft: number;
    expiresOn: string;
    expired: boolean;
    warning: boolean;
}

export interface HallLicenseState {
    hallId: number;
    automated: boolean;
    duration: number;
    warningPeriod: number;

    inProgress?: LicenseDates;
    applied?: LicenseDates;
}

export const checkObjectWithSchema = (node, schema, childSchema?) => {
    Object.keys(node).map(key => {
        if (
            (schema.properties &&
                Object.keys(schema.properties).includes(key) &&
                schema.properties[key].hasOwnProperty("convert") &&
                schema.properties[key].convert == true) ||
            (schema.items &&
                schema.items.properties &&
                Object.keys(schema.items.properties).includes(key) &&
                schema.items.properties[key].hasOwnProperty("convert") &&
                schema.items.properties[key].convert == true) ||
            (childSchema &&
                childSchema.properties &&
                Object.keys(childSchema.properties).includes(key) &&
                childSchema.properties[key].hasOwnProperty("convert") &&
                childSchema.properties[key].convert == true)
        ) {
            if (key === "fractionated_jackpot_list") {
                node[key].map((f, index) => {
                    Object.keys(f).map((key, index) => {
                        f[key] = f[key] * 100
                        f[key] = parseInt(f[key])
                    })
                    f.bet = index + 1
                })
            } else node[key] = Math.round(Number(node[key]) * 100)
        }
    });

    return node;
};

export const checkObjectWithSchemaToConvert = (node, schema, childSchema?) => {
    Object.keys(node).map(key => {
        if (
            (schema.properties &&
                Object.keys(schema.properties).includes(key) &&
                schema.properties[key].hasOwnProperty("convert") &&
                schema.properties[key].convert == true) ||
            (schema.items &&
                schema.items.properties &&
                Object.keys(schema.items.properties).includes(key) &&
                schema.items.properties[key].hasOwnProperty("convert") &&
                schema.items.properties[key].convert == true) ||
            (childSchema &&
                childSchema.properties &&
                Object.keys(childSchema.properties).includes(key) &&
                childSchema.properties[key].hasOwnProperty("convert") &&
                childSchema.properties[key].convert == true)
        ) {
            node[key] = Number(node[key]) / 100;
        }
    });

    return node;
};

export const checkIfConditionMeet = (form_values, schema) => {
    if (schema.hasOwnProperty("if")) {
        const conditions = schema["if"].properties;
        let result = false;
        Object.keys(conditions).map(property => {
            if (form_values.hasOwnProperty(property)) {
                if (conditions[property].hasOwnProperty("const")) {
                    if (
                        form_values[property] == conditions[property]["const"]
                    ) {
                        result = true;
                    }
                }

                if (conditions[property].hasOwnProperty("pattern")) {
                    if (
                        form_values[property].match(
                            conditions[property]["pattern"]
                        )
                    ) {
                        result = true;
                    }
                }
            }
        });

        return result;
    }

    return false;
};

const checkHallLicenseState = (license: License): HallLicenseState => {
    if (!license) {
        return null;
    }

    const state: HallLicenseState = {
        hallId: license.hall_id,
        automated: license.automated,
        duration: license.duration,
        warningPeriod: license.warning_period
    };

    if (license.generation) {
        const generatedOn = moment(license.generation);

        if (generatedOn) {
            const inProgressExpiresOn = moment(generatedOn).add(
                license.duration,
                "days"
            );
            const inProgressWarningOn = moment(inProgressExpiresOn).subtract(
                license.warning_period,
                "days"
            );

            state.inProgress = {
                daysLeft: moment(inProgressExpiresOn)
                    .add(20, "hours")
                    .diff(moment(), "days"),
                expiresOn: moment(inProgressExpiresOn).format("YYYY-MM-DD"),
                expired: moment().isAfter(moment(inProgressExpiresOn)),
                warning:
                    moment().isSameOrAfter(moment(inProgressWarningOn)) &&
                    moment().isBefore(moment(inProgressExpiresOn))
            };
        }

        if (license.expiration) {
            const expiresOn = moment(license.expiration);

            if (expiresOn) {
                const warningOn = moment(expiresOn).subtract(
                    license.warning_period,
                    "days"
                );

                state.applied = {
                    daysLeft: moment(expiresOn)
                        .add(20, "hours")
                        .diff(moment(), "days"),
                    expiresOn: moment(expiresOn).format("YYYY-MM-DD"),
                    expired: moment().isAfter(moment(expiresOn)),
                    warning:
                        moment().isSameOrAfter(moment(warningOn)) &&
                        moment().isBefore(moment(expiresOn))
                };
            }
        }
    }

    window["moment"] = moment;
    window["_license"] = license;
    window["_state"] = state;

    return state;
};

export const Utils = {
    checkHallLicenseState
};

export const checkRenderForProvider = (key, providerSchema) => {
    return (
        providerSchema[key] == undefined ||
        Array.isArray(providerSchema[key].type) ||
        providerSchema[key].type != "null"
    );
};

export const checkDefaultForType = (
    type,
    emun = undefined,
    isRequired = undefined
) => {
    if (type == "string") {
        return "";
    } else if (type == "boolean") {
        return false;
    } else if (type == "null") {
        return null;
    } else if (type == "array") {
        return [];
    } else if (type == "integer") {
        if (emun && Array.isArray(emun)) {
            return emun[0];
        }
        return null;
    } else if (type == "number") {
        if (emun && Array.isArray(emun)) {
            return emun[0];
        }
        return null;
    } else if (Array.isArray(type) && isRequired === true) {
        return checkDefaultForType(type[0]);
    } else if (Array.isArray(type) && isRequired === false) {
        return null;
    } else {
        return "";
    }
};

export const getNewGeneratedId = (key, configs = []) => {
    let flattenIds = configs.map(config => config.id);
    let newId = `${key}-00`;
    for (let i = 0; i <= 99; i++) {
        let generatedId = `${key}-${("0" + i).slice(-3)}`;
        if (!flattenIds.includes(generatedId)) {
            newId = generatedId;
            break;
        }
    }

    return newId;
};

export const getNewGeneratedName = (key, configs = []) => {
    let flattenNames = configs.map(config => config.name);
    let newName = `${key}-00`;
    for (let i = 0; i <= 99; i++) {
        let generatedName = `${key}-${("0" + i).slice(-3)}`;
        if (!flattenNames.includes(generatedName)) {
            newName = generatedName;
            break;
        }
    }

    return newName;
};

export const formatDateText = (
    date,
    month_type = "short",
    show_year = true,
    show_date = true,
    show_time = false
) => {
    date = new Date(date);
    let str_date = "";
    const year = date.toLocaleDateString("en-US", {year: "numeric"});
    const time = date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit"
    });
    if (show_date)
        str_date +=
            (str_date.length > 0 ? " " : "") +
            date.toLocaleDateString("en-US", {day: "numeric"}) +
            " " +
            date.toLocaleDateString("en-US", {month: month_type});
    if (show_year) str_date += (str_date.length > 0 ? " " : "") + year;
    if (show_time) str_date += " @ " + time;
    return str_date;
};

export const forceDownload = (url, name) => {
    let headers = {};

    const token = localStorage.getItem("sessionid");
    if (token) {
        headers["Authorization"] = "Bearer " + token;
    }
    fetch(url, {
        headers: {
            "Authorization": "Bearer " + token
        }
    }).then(response => {
        response.blob().then(blob => {
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = name;
            a.click();
        });
    });
};

export const uuidv4 = () => {
    return `${[1e7]}-${1e3}-${4e3}-${8e3}-${1e11}`.replace(/[018]/g, c =>
        (
            (c as any) ^
            (crypto.getRandomValues(new Uint8Array(1))[0] &
                (15 >> ((c as any) / 4)))
        ).toString(16)
    );
};

export const removeAccents = str => {
    let accents =
        "ÀÁÂÃÄÅàáâãäåßÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž";
    let accentsOut =
        "AAAAAAaaaaaaBOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";
    str = str.split("");
    str.forEach((letter, index) => {
        let i = accents.indexOf(letter);
        if (i != -1) {
            str[index] = accentsOut[i];
        }
    });
    return str.join("");
};

export const versionCompare = (a, b) => {
    let x = a.split(".").map(e => parseInt(e));
    let y = b.split(".").map(e => parseInt(e));
    let z = "";

    for (var i = 0; i < x.length; i++) {
        if (x[i] === y[i]) {
            z += "e";
        } else if (x[i] > y[i]) {
            z += "m";
        } else {
            z += "l";
        }
    }
    if (!z.match(/[l|m]/g)) {
        return 0;
    } else if (z.split("e").join("")[0] == "m") {
        return 1;
    } else {
        return -1;
    }
};
